import cloneDeep from 'lodash/cloneDeep';
import set from 'lodash/set';
export var setModuleStateAtPath = function setModuleStateAtPath(modulePath) {
  return function (surface, newProps) {
    var surfaceCopy = cloneDeep(surface);
    switch (true) {
      case newProps === null:
        set(surfaceCopy, modulePath, null);
        break;
      case newProps.hasOwnProperty('componentName') && newProps.hasOwnProperty('props'):
        set(surfaceCopy, "".concat(modulePath, ".name"), newProps.componentName);
        set(surfaceCopy, "".concat(modulePath, ".fields"), newProps.props);
        break;
      default:
        set(surfaceCopy, "".concat(modulePath, ".fields"), newProps);
        break;
    }
    return surfaceCopy;
  };
};